import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-slate-900 text-slate-100 relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-7">
            <p className="font-mono uppercase tracking-[0.24em] text-xs text-slate-400 mb-8">
              A cohort for practitioners
            </p>
            <h2 className="font-serif text-5xl md:text-7xl leading-[0.95] tracking-tight text-slate-50">
              Build systems<br />
              <span className="italic text-slate-300">that actually ship.</span>
            </h2>
            <Link
              to="/apply"
              data-testid="footer-apply-btn"
              className="inline-block mt-12 border border-slate-500 hover:border-slate-100 text-slate-100 px-8 py-4 font-sans tracking-wide transition-colors"
            >
              Begin your application →
            </Link>
          </div>

          <div className="md:col-span-5 md:pl-8 grid grid-cols-2 gap-8 text-sm">
            <div>
              <p className="font-mono uppercase text-xs tracking-[0.24em] text-slate-400 mb-4">
                Contact
              </p>
              <a href="mailto:umashankerkh@gmail.com" className="text-slate-300 font-sans mb-2 block hover:text-white transition-colors">
                umashankerkh@gmail.com
              </a>
              <a href="tel:+919483632823" className="text-slate-400 text-xs font-mono hover:text-slate-200 transition-colors">
                +91 94836 32823
              </a>
            </div>
            <div>
              <p className="font-mono uppercase text-xs tracking-[0.24em] text-slate-400 mb-4">
                Program
              </p>
              <ul className="space-y-2 text-slate-300 font-sans">
                <li>7 – 8 months</li>
                <li>600+ hours</li>
                <li>Live labs · Capstone</li>
              </ul>
            </div>
            <div>
              <p className="font-mono uppercase text-xs tracking-[0.24em] text-slate-400 mb-4">
                Next cohort
              </p>
              <p className="text-slate-300 font-sans">Contact us</p>
            </div>
            <div>
              <p className="font-mono uppercase text-xs tracking-[0.24em] text-slate-400 mb-4">
                Investment
              </p>
              <p className="text-slate-300 font-sans">Contact us</p>
            </div>
          </div>
        </div>

        <div className="hair-rule my-16 opacity-40" />

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between text-xs font-mono text-slate-500 uppercase tracking-widest gap-4">
          <span>FDE AI Industry Practitioner Program · {new Date().getFullYear()}</span>
          <span>Instructor-led · Live labs · Industry sprints · Capstone</span>
        </div>

        <div className="mt-8 pt-8 border-t border-slate-800">
          <p className="text-[11px] font-sans text-slate-500 leading-relaxed max-w-4xl">
            This is an independent professional training and coaching program conducted by Umashankar K H in his personal capacity as an industry practitioner. The FDE AI Industry Practitioner certificate is a practitioner certificate issued by the instructor — it is not a government-recognised degree, diploma, or qualification under UGC, AICTE, or any statutory body. References to IIT Gandhinagar and IIT Roorkee reflect prior contract engagements as an invited instructor and do not imply any affiliation, endorsement, or certification by those institutions. By applying or enrolling, participants agree to the program's Terms &amp; Conditions and acknowledge that all personal data is collected and processed solely for program administration in accordance with applicable Indian law.
          </p>
        </div>
      </div>
    </footer>
  );
}
